import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
name: 'thousandSeparator',
pure: true
})


export class MaskPipe implements PipeTransform {

  transform(value: string): any {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}